<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Cotización de Dólar</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <dollar-quotation-form v-if="isDataLoaded" :dollar-quotation="dollarQuotation" @save="saveDollarQuotation" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import DollarQuotationForm from './Forms/DollarQuotationForm.vue';
import swal from 'sweetalert2';

export default {
  name: 'DollarQuotationEdit',
  components: {
    RouteBreadCrumb,
    DollarQuotationForm,
  },

  data() {
    return {
      dollarQuotation: null,
      isDataLoaded: false,
    };
  },

  created() {
    const dollarQuotationId = this.$route.params.id;
    this.fetchDollarQuotation(dollarQuotationId);
  },

  methods: {
    fetchDollarQuotation(id) {
      this.$services
        .resource('dollar_quotations')
        .show(id)
        .then((res) => res.data.data)
        .then((dollarQuotation) => {
          this.dollarQuotation = dollarQuotation;
          this.isDataLoaded = true;
        });
    },

    saveDollarQuotation(changes) {
      this.$services
        .resource('dollar_quotations')
        .update(this.dollarQuotation.id, changes)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'La cotización para el dólar fue actualizada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'DollarQuotationList' }));
        });
    },
  },
};
</script>
